import { Key, useState } from 'react'
import { Button, Flex, Table } from 'antd'
import { BudgetRequest } from 'src/pages/budget/budgetRequests/types'
import { PAGE_SIZE } from 'src/pages/budget/budgetCategories/const'
import { TStatusPeriod } from 'src/pages/budget/types'
import {
  FilterTable,
  getRequestListColumns,
} from 'src/pages/budget/budgetRequests/components'
import {
  filtersChangedBudgetListUrgent,
  openModalRequestsCopy,
} from 'src/pages/budget/budgetRequests/model'

type Props = {
  list: BudgetRequest[]
  filterList: BudgetRequest[]
  currentPeriodStatus?: TStatusPeriod
}
export const UrgentTable = ({
  list,
  filterList,
  currentPeriodStatus,
}: Props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([])
  const selectedRequests = list.filter(({ id }) => selectedRowKeys.includes(id))

  return (
    <Flex vertical gap="middle" style={{ width: '100%' }}>
      <Flex justify="space-between" gap={8}>
        <Flex>
          {selectedRequests.length > 0 && (
            <Button
              size="middle"
              color="geekblue"
              variant="solid"
              onClick={() => openModalRequestsCopy({ items: selectedRequests })}
            >
              Скопировать ({selectedRequests.length})
            </Button>
          )}
        </Flex>
        <FilterTable
          fields={[
            'articleName',
            'createdBy',
            'status',
            'products',
            'searchText',
          ]}
          onChange={(value) => {
            setSelectedRowKeys([])
            filtersChangedBudgetListUrgent(value)
          }}
          list={list}
        />
      </Flex>
      <Table
        dataSource={filterList}
        tableLayout="fixed"
        rowSelection={{
          type: 'checkbox',
          columnWidth: 32,
          selectedRowKeys,
          onChange: (keys) => setSelectedRowKeys(keys),
        }}
        pagination={
          filterList.length > PAGE_SIZE
            ? {
                total: filterList.length,
                defaultPageSize: PAGE_SIZE,
                showSizeChanger: true,
                position: ['bottomCenter'],
              }
            : false
        }
        columns={getRequestListColumns(
          [
            'id',
            'articleName',
            'itemName',
            'description',
            'amount',
            'createdBy',
            'productIds',
            'status',
            'actionUrgent',
          ],
          currentPeriodStatus,
          false,
          true,
        )}
        rowKey={(record) => record.id}
        rowClassName={(_, index) =>
          `ant_table_row_height ${index % 2 ? 'even-row' : 'odd-row'}`
        }
      />
    </Flex>
  )
}
